import { attributesMathSchema } from "./attributes.js";
import { validate } from "../../helpers/validate.js";
import { guideMathHtml } from "../../elements/math/components.js";
const scalarMath = {
  name: "scalar-math",
  tagName: "scalar-math",
  tiptapName: "math",
  attributeTransform: (content, attributes) => {
    return validate(attributesMathSchema, {
      equation: attributes.equation ? attributes.equation.toString() : content,
      caption: attributes.caption ? attributes.caption.toString() : ""
    });
  },
  render: async (props) => guideMathHtml(props)
};
import { ScalarMathVue } from "./components.js";
export {
  ScalarMathVue,
  scalarMath
};
//# sourceMappingURL=index.js.map
